/* Next */
import Link from 'src/components/Link'
import { hrefForBrandPath } from 'src/functions/navigationBreadcrumbs'

/* Types */
import { tBrand } from 'src/shared/frontendTypes/brand'

/* Options */
import config from 'src/config'

interface Props {
  brand: tBrand
  large?: boolean
}

const Brand: React.FC<Props> = ({ brand, large = false }) => {

  const logo = brand.logos?.mono
  if (!logo?.xs) return null
  
  const logoPath = `${config.image_server}/brand/${large ? logo.sm || logo.xs : logo.xs}`
  const href = hrefForBrandPath(brand.path, brand.id) || '/brands'
  
  return <Link legacyBehavior {...{href}}>
    <a title={brand.metaTitle} >
      <img
        src={logoPath}
        alt={brand.titel}
        width={large ? 152 : 100} height={large ? 110 : 100}
        loading='eager'
      />
    </a>
  </Link>
}

export default Brand
